module.exports = __webpack_public_path__ + "images/questions/qa_human_01_186938b7ef9c12786a57390e9cca7926.png";